module.exports = __webpack_public_path__ + "assets/img/menu-progress-white.b7018474.svg";